import React from "react";
import { ShiftDisplayWrapper, TimeDisplayWrapper, TimestampCellWrapper } from "../styledComponents";
import { TimeDisplay } from "./TimeDisplay";
import { TimeArrow } from "../arrow";
import { ShiftComponent, TimesheetsShiftInfo } from "../../../types/Shift.types";
import { PayrollHoursStatus, TimesheetTabs } from "../../../types/Payroll.types";
import { ApprovalTextDisplay } from "./ApprovalTextDisplay";

type ClockInOutCellProps = {
  shiftInfo: TimesheetsShiftInfo;
  openModal: () => void;
  showMessaging?: boolean;
  shiftKey: string;
  activeTabIndex?: TimesheetTabs;
};

export const ClockInOutCell = ({
  shiftInfo,
  openModal,
  showMessaging,
  shiftKey,
  activeTabIndex,
}: ClockInOutCellProps) => {
  const { userShift } = shiftInfo;
  const showApproval = userShift.status === PayrollHoursStatus.APPROVED;

  return (
    <TimestampCellWrapper onClick={openModal}>
      <ShiftDisplayWrapper showApproval={showApproval}>
        <TimeDisplayWrapper spaced>
          <TimeDisplay
            timestamp={userShift.start}
            shiftInfo={shiftInfo}
            tsType={ShiftComponent.CLOCK_IN}
            shiftKey={shiftKey}
            showMessaging={showMessaging}
          />
        </TimeDisplayWrapper>
        <TimeArrow />
        <TimeDisplayWrapper spaced>
          <TimeDisplay
            timestamp={userShift.end}
            shiftInfo={shiftInfo}
            tsType={ShiftComponent.CLOCK_OUT}
            shiftKey={shiftKey}
            showMessaging={showMessaging}
          />
        </TimeDisplayWrapper>
      </ShiftDisplayWrapper>
      {showApproval && (
        <ApprovalTextDisplay
          isAutoApproved={userShift.isAutoApproved}
          lastUpdatedBy={userShift.lastUpdateBy!!}
          statusReason={userShift.statusReason}
          activeTabIndex={activeTabIndex}
          wasDisputed={userShift.wasDisputed}
        />
      )}
    </TimestampCellWrapper>
  );
};
